import { LuSearch, LuX } from "react-icons/lu";
import {
  useProjectsListActions,
  useProjectsListSearchQuery,
} from "../../../core_stores/useProjectsListStore";
import { colors, typography, effects } from "../../../design/tokens";

export default function SideMenuSearchField(): JSX.Element {
  const searchQuery = useProjectsListSearchQuery();
  const { onSearchQueryChange } = useProjectsListActions();

  function handleClear(): void {
    onSearchQueryChange("");
  }

  function handleChange(e: React.ChangeEvent<HTMLInputElement>): void {
    onSearchQueryChange(e.target.value);
  }

  return (
    <div className="relative">
      <input
        type="text"
        placeholder="Search projects..."
        value={searchQuery}
        className={`w-full ${colors.surface.secondary} ${colors.text.primary}
          placeholder-dark-placeholder ${effects.borderRadius.full}
          py-2 pl-10 pr-10 ${typography.size.sm}
          border ${colors.border.primary}
          focus:outline-none focus:border-primary-blue transition-colors`}
        onChange={handleChange}
      />
      <LuSearch
        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-dark-text-muted"
        size={20}
      />
      {searchQuery && (
        <button
          onClick={handleClear}
          className="absolute right-3 top-1/2 transform -translate-y-1/2
            text-dark-text-muted hover:text-dark-text transition-colors duration-200"
        >
          <LuX size={16} />
        </button>
      )}
    </div>
  );
}
